import CustomRenderer from "./customRenderer";

export default () => ({
  __depends__: ["styles"],
  __init__: ["customRenderer"],
  customRenderer: ["type", CustomRenderer]
});
